(function () {
    angular
        .module('advancedapp')
        .component('categoryFilterComponent', {
            restrict: 'E',
            bindings: {
                categoryResult: '<',
                searchTerm: '@',
                onChange: '&',
                rootPageId: '<'
            },
            template: require('../category-filter/category-filter-component.html'),
            controller: controller,
            controllerAs: 'vm'
        });

    controller.$inject = ['$log', '$window', 'search_service'];

    function controller($log, $window, search_service) {

        var vm = this;

        vm.searchModel = {
            searchTerm: "",
            categories: [],
            sortBy: 0,
            rootPageId: 0,
        };

        vm.$onChanges = function (changesObj) {
            //console.log("Changes Obj");
            //console.log(changesObj);
            if (changesObj.categoryResult && changesObj.categoryResult.currentValue) {
                vm.categories = changesObj.categoryResult.currentValue;
            }

            if (changesObj.searchTerm) {
                vm.searchTerm = changesObj.searchTerm.currentValue;
            }

            if (changesObj.rootPageId && changesObj.rootPageId.currentValue) {
                vm.rootPageId = changesObj.rootPageId.currentValue;
                vm.searchModel.rootPageId = vm.rootPageId;
            }
        };

        vm.change = function (catId, catName) {
            //console.log("categories", vm.searchModel.categories);
            if (!includes(vm.searchModel.categories, catId)) {
                vm.searchModel.categories.push(catId);
            }
            else {
                vm.searchModel.categories.splice(vm.searchModel.categories.indexOf(catId), 1);
            }
            vm.searchModel.searchTerm = vm.searchTerm;

            changeCat(vm.searchModel);
        };

        function changeCat(model) {
            vm.onChange({ model });
        }

        function includes(container, value) {
            var returnValue = false;
            var pos = container.indexOf(value);
            if (pos >= 0) {
                returnValue = true;
            }
            return returnValue;
        }
    }
})();